<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <!-- 头部 -->
    <div class="page-heading">
      <div class="container">
        <div class="heading-content">
          <h1>ENGINEERING</h1>
        </div>
      </div>
    </div>
    <!-- 导航栏 -->
    <div class="tabs tabs-style-linebox hidden-xs">
      <div class="zznav">
        <ul class="zzitem">
          <li><a @click="forId('hysj')">Huayin Design</a></li>
          <li><a @click="forId('zpjx')">Work analysis</a></li>
        </ul>
      </div>
    </div>
    <!-- 小滚轮 -->
    <div id="ss_menu" v-show="this.showButton">
      <div>
        <i
          ><a @click="forId('zpjx')">Work<br />analysis</a></i
        >
      </div>
      <div>
        <i
          ><a @click="forId('hysj')">Huayin<br />Design</a></i
        >
      </div>
      <div class="menu">
        <div class="share" id="ss_toggle" data-rot="180">
          <div class="circle"></div>
          <div class="bar"></div>
        </div>
      </div>
    </div>
    <!-- 华胤设计 -->
    <div class="jzcontainer" id="hysj">
      <div class="jzleft">
        <img v-lazy="hycz1" alt="Lazy-loaded Image" class="jzimg" />
      </div>
      <div class="jzright">
        <h1 class="jzh">Huayin Design</h1>
        <p class="jzp">
          Project is designed based on modern design Concept and relevant
          official codes and standards.<br />
          HUAYIN has its own design center with Steel Structure Designing
          Certificate of Class A and is located in Kunshan city.<br />
          HUAYIN own advanced international and domestic design software such as
          MBS, X-STEEL, PKPM, 3D3S, STAAD PRO, MBS, MTS, CFS, XSTEEL, etc. We
          are able to do from structure design to the shop drawing, a total of
          3000 design cases has been done since our establishment.<br />
          We provide complete detailed shop drawings, erection drawings and
          material list to insure that the manufacturing and construction
          processes can proceed accurately and efficiently.
        </p>
      </div>
    </div>
    <!-- 作品解析 -->
    <div id="zpjx"><h1 class="jzcph">Compositions</h1></div>
    <div class="jzcp">
      <div class="cd-image-block">
        <ul class="cd-images-list">
          <li class="is-selected">
            <a href="#0">
              <h2>Shanghai SECCO PHU WAREHOUSE PROJECT</h2>
            </a>
          </li>

          <li>
            <a href="#0">
              <h2>IKEA Logistic Center Project in SongJiang Area,Shanghai</h2>
            </a>
          </li>

          <li>
            <a href="#0">
              <h2>Xian Airplane Hangar Project</h2>
            </a>
          </li>

          <li>
            <a href="#0">
              <h2>Tenhong Investment (Shanghai) Group</h2>
            </a>
          </li>
          <li>
            <a href="#0">
              <h2>Toyota Auto Parts Industry (Kunshan) Co., Ltd.</h2>
            </a>
          </li>
          <li>
            <a href="#0">
              <h2>Toyota Auto Parts Industry (Kunshan) Co., Ltd.</h2>
            </a>
          </li>
          <li>
            <a href="#0">
              <h2>YKK zipper Yoshida (Shenzhen) Co., Ltd.</h2>
            </a>
          </li>
          <li>
            <a href="#0">
              <h2>Caojing Joint Isocyanate Chemical Project in Shanghai, China</h2>
            </a>
          </li>
          <li>
            <a href="#0">
              <h2>Polysius special-shaped steel structure</h2>
            </a>
          </li>
          <li>
            <a href="#0">
              <h2>Shanghai World Expo Expo Center</h2>
            </a>
          </li>
          <li>
            <a href="#0">
              <h2>Giant bridge steel structure</h2>
            </a>
          </li>
          <li>
            <a href="#0">
              <h2>Wuhan Iron and Steel Park pipe quilting composite column</h2>
            </a>
          </li>
        </ul>
        <!-- .cd-images-list -->
        <ul class="block-navigation">
          <li>
            <button class="cd-prev inactive jzbutton">&larr; Previous</button>
          </li>
          <li><button class="cd-next jzbutton">Next &rarr;</button></li>
        </ul>
        <!-- .block-navigation -->
      </div>
      <!-- .cd-image-block -->

      <div class="cd-content-block">
        <ul>
          <li class="is-selected">
            <div>
              <h2>Shanghai SECCO PHU WAREHOUSE PROJECT</h2>
              <img
                v-lazy="hycz2"
                alt="Lazy-loaded Image"
                style="width: 50vw; margin: -10px 5px 5px 5px; max-height: 30vh"
              />
              <p>
                The SECCO Petrochemical PHU warehouse project is a full steel
                structure design that handles packing/storage/distribution of
                900 thousand tons of Ethylene annually.It is located in the
                famous Shanghai chemical Industrial Zone in Jinshan Area. The
                construction floor area is 60,927 square meters and the main
                structure has a length of 396 meter and a width of 148 meter.<br />
                SECCO is a joint venture cooperation of the world leading
                enterprise includes BP, Sinopec and Shanghai Petro.
              </p>
            </div>
          </li>

          <li>
            <div>
              <h2>IKEA Logistic Center Project in SongJiang Area,Shanghai</h2>
              <img
                v-lazy="hycz3"
                alt="Lazy-loaded Image"
                style="width: 50vw; margin: -10px 5px 5px 5px"
              />
              <p>
                This project is located in Dong Jing Industrial Park with a
                total construction floor area of 63218 square meters and double
                slope roofing system. Height of cornice in center line is 30
                meters and the construction work was much harder than those of
                other ordinary light steel structure systems.
              </p>
            </div>
          </li>

          <li>
            <div>
              <h2>Xian Airplane Hangar Project</h2>
              <img
                v-lazy="hycz4"
                alt="Lazy-loaded Image"
                style="width: 50vw; margin: -10px 5px 5px 5px"
              />
              <p>
                The Xian Airplane Hangar has an extra wide 64 meter span which
                is particularly impressive among all our project references done
                before. In this project the advantage of steel construction
                scheme can be fully demonstrated, if compared to other
                structural plan.<br />
                In this 5200 square meter huge steel structure, there is
                functional need to keep very efficient movement of airplanes, as
                such, steel construction that allows large span had became the
                best solution for reducing the use of columns as support.<br />
                In additional, this Steel construction plan has advantage of
                shortening construction time, if compared to the steel grid
                system.
              </p>
            </div>
          </li>

          <li>
            <div>
              <h2>Tenhong Investment (Shanghai) Group</h2>
              <img
                v-lazy="hycz5"
                alt="Lazy-loaded Image"
                style="width: 50vw; margin: -10px 5px 5px 5px"
              />
              <p>
                The north coast & long wind business complex megaproject is
                planned and invested by the Tenhong investment Group with a
                total of 3 billion Chinese Yuan and total construction area of
                290 thousand square meter.<br />
                There are 12 big buildings in this megaproject and we are
                awarded design and construction of Nr.2 west office building
                located in the Long Wind area which was constructed alongside
                the famous Suzhou River.<br />
                he main structure system is with 5 floors of steel construction
                plus one floor basement with concrete. The total construction
                area is 18168 square meter and with an average 4.2 meter high as
                standard height of floors.
              </p>
            </div>
          </li>
          <li>
            <div>
              <h2>Toyota Auto Parts Industry (Kunshan) Co., Ltd.</h2>
              <img
                v-lazy="hycz6"
                alt="Lazy-loaded Image"
                style="width: 50vw; margin: -10px 5px 5px 5px"
              />
              <p>
                Huayin attention to each project technical support and
                after-sales service, the country set up a number of district
                offices to ensure that customers can easily obtain timely Huayin
                services. Most well-known companies are Huayin customers, such
                as: the Sinar Mas Group, China Air Cargo Group, Yinlu Group,
                Liuhe Group, Wuhan Iron and Steel Group, Ting Hsin Group, Yangzi
                Petrochemical, Tesco Tesco supermarket, Japan - iron, Fengshen
                Motor Toyota, Nine dragons Paper, Mengniu Dairy, Nokia mobile
                communications, Philips lighting Electronics, Siemens, Acer,
                Samsung, TDK tape, YKK zippers, BASF petrochemical, Hitachi,
                Midea, Ikea and many other well-known domestic and foreign
                enterprises. Huayin engineering achievements from food,
                electronics, paper, medicine to logistics, automotive,
                aerospace, chemical ...... covering all walks of life; but also
                export to the United States, Japan, Europe, Australia, South
                Korea, Thailand, Haiti and even South Africa, Angola and other
                non-state area.
              </p>
            </div>
          </li>
          <li>
            <div>
              <h2>Creative Attitude Clothing (Shanghai) Co., Ltd.</h2>
              <img
                v-lazy="hycz7"
                alt="Lazy-loaded Image"
                style="width: 50vw; margin: -10px 5px 5px 5px"
              />
              <p>
                Huayin has a complete design center, effectively ensure the
                design, manufacturing, project management and be able to
                communicate directly and fluid exchange. With modern production
                technology manufacturing plant for the company to provide
                production capacity 50,000 tons and 30,000 tons of heavy steel
                member forming member. Quality management and welding
                manufacturing level through the United States, Europe, Japan,
                China and other certification authority, Huayin factory by
                American Institute of Steel Construction Quality Certification
                (AISC), welding quality system manufactured by the American
                Welding Society (AWS) (CWF) and Germany LGA certification
                welding system certification by the Netherlands DNV, Swiss SGS
                ISO9001 quality system certification.All manufacturing processes
                and quality control in accordance with standard operating
                procedures.
              </p>
            </div>
          </li>
          <li>
            <div>
              <h2>YKK zipper Yoshida (Shenzhen) Co., Ltd.</h2>
              <img
                v-lazy="hycz8"
                alt="Lazy-loaded Image"
                style="width: 50vw; margin: -10px 5px 5px 5px"
              />
              <p>
                Huayin Steel Works (China) Co., Ltd. is a wholly foreign-owned
                enterprises, under Huayin Group, specializing in pre-engineered
                steel building systems and related accessories for the design,
                manufacture and construction. The company was established in
                1994 by the number of years the United States and Australia
                prefabricated steel structure system experienced professional
                engineers. Huayin very proud to have a professional team for the
                company's high quality and efficient operations management.
                Through the joint efforts of the team, Huayin has successfully
                completed more than 3,000 projects, construction area of more
                than 10 million square meters, repeatedly won the "Jingang
                Award", "Engineering Quality Quality Award" and other types of
                awards.
              </p>
            </div>
          </li>
          <li>
            <div>
              <h2>Caojing Joint Isocyanate Chemical Project in Shanghai, China</h2>
              <img
                v-lazy="hycz9"
                alt="Lazy-loaded Image"
                style="width: 50vw; max-height: 40vh; margin: -10px 5px 5px 5px"
              />
              <p>
                Located in Shanghai Caojing Chemical Industrial Park, Shanghai Caojing Joint Isocyanate Chemical Project (IIP) is jointly invested and built by Shanghai BASF Polyurethane Co., Ltd. (BASF), Shanghai Lianheng Isocyanate Co., Ltd. (SLIC) and Huntsman Polyurethane Shanghai Co., Ltd. (HPS). Huayin is responsible for the design of the junction, and contracted about 70% of the total amount of the project to produce steel structures, a total of 9,200 tons, all distributed in 28 large blocks and 17 small blocks. The lines of the whole project are extremely complex, showing an extraordinary sassy and heroic posture, which makes the steel structure have a myriad of styles.
              </p>
            </div>
          </li>
          <li>
            <div>
              <h2>Polysius special-shaped steel structure</h2>
              <img
                v-lazy="hycz10"
                alt="Lazy-loaded Image"
                style="width: 50vw; max-height: 40vh; margin: -10px 5px 5px 5px"
              />
              <p>
                The POLYSIUS slag warehouse cap manufactured by Huayin is a conical three-dimensional structure with 24 sides, where 24 beams will be connected to one point, and the requirements for component size and deformation control are very high. The overall size of the structure is 4744mm at the big end and 3114mm at the small end; The length of the weld reaches 352 meters, of which 60 meters is fully penetrated, and the welding operation space is very limited, which has high requirements for welding technology. <br />
                Polysius W11-17 special-shaped steel structure is cylindrical, and the cylinder is divided into 16 equal parts by 16 corbels, each equal part is 22.5°. W11-17 has a total width of 5634mm, a cylindrical inner diameter of 2600mm, and a height of 1443mm. Due to the complex structure and the difficulty of welding, careful construction is required.
              </p>
            </div>
          </li>
          <li>
            <div>
              <h2>Shanghai World Expo Expo Center</h2>
              <img
                v-lazy="hycz11"
                alt="Lazy-loaded Image"
                style="width: 50vw; max-height: 40vh; margin: -10px 5px 5px 5px"
              />
              <p>
                The Shanghai World Expo Center adopts a new type of buckling restraint support as an energy-dissipating shock absorption system, which can yield under tension and compression, and obtain a full load-displacement hysteresis curve. This support consists of a core plate, a restraint sleeve and an outer sleeve made of low yield point steel, because the restraint sleeve must have a good restraining effect on the buckling of the core plate and withstand the extrusion force generated by the buckling bending of the core plate on the sleeve. Therefore, the manufacturing precision and difficulty are very high. The World Expo Performing Arts Center is one of the most important permanent venues of the Shanghai World Expo, and will host various large-scale performances and activities during the Expo. The Performing Arts Center will be built into a world-class modern performing arts venue.
              </p>
            </div>
          </li>
          <li>
            <div>
              <h2>Giant bridge steel structure</h2>
              <img
                v-lazy="hycz12"
                alt="Lazy-loaded Image"
                style="width: 50vw; max-height: 40vh; margin: -10px 5px 5px 5px"
              />
              <p>
                Due to the simultaneous existence of three factors: upward arching, plane bending arc, and 14-degree inclination of the webs on both sides of the bridge, the giant bridge forms an extremely complex three-dimensional space structure. This has brought insurmountable difficulties to the blanking, assembly and welding of the bridge. Huge bridges are unprecedentedly challenging, both turned over and transported during processing. Huayin's technical department and manufacturing department have overcome this problem, which gives Huayin the ability to challenge any bridge structure.
              </p>
            </div>
          </li>
          <li>
            <div>
              <h2>Wuhan Iron and Steel Park pipe quilting composite column</h2>
              <img
                v-lazy="hycz13"
                alt="Lazy-loaded Image"
                style="width: 50vw; max-height: 40vh; margin: -10px 5px 5px 5px"
              />
              <p>
                The round tube steel frame column of the pipe truss steel structure is a common structural form, which is assembled by the upper and lower sections. The upper section is usually made of conventional BH steel columns, while the lower section is made of double round pipes. This design makes the structure of the steel column more stable and strong.<br>
                In this construction, the corbel plays the role of connecting the upper and lower steel columns, and the corbel is installed on the top of the double round pipe column by insertion.This design structure can provide good load-bearing capacity and stability, and is suitable for a variety of buildings and structures. By using round tubular steel frame columns, a fast and efficient assembly and installation process can be achieved while ensuring the strength and stability of the structure.
              </p>
            </div>
          </li>
        </ul>

        <button class="cd-close jzbutton">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  mounted() {
    // 产品介绍
    $(document).ready(function ($) {
      //store DOM elements
      var imageWrapper = $('.cd-images-list'),
        imagesList = imageWrapper.children('li'),
        contentWrapper = $('.cd-content-block'),
        contentList = contentWrapper.children('ul').eq(0).children('li'),
        blockNavigation = $('.block-navigation'),
        blockNavigationNext = blockNavigation.find('.cd-next'),
        blockNavigationPrev = blockNavigation.find('.cd-prev'),
        //used to check if the animation is running
        animating = false

      //on mobile - open a single project content when selecting a project image
      imageWrapper.on('click', 'a', function (event) {
        event.preventDefault()
        var device = MQ()
        console.log(device)
        device == 'mobile' &&
          updateBlock(imagesList.index($(this).parent('li')), 'mobile')
      })

      //on mobile - close visible project when clicking the .cd-close btn
      contentWrapper.on('click', '.cd-close', function () {
        var closeBtn = $(this)
        if (!animating) {
          animating = true

          closeBtn
            .removeClass('is-scaled-up')
            .one(
              'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
              function () {
                contentWrapper
                  .removeClass('is-visible')
                  .one(
                    'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
                    function () {
                      animating = false
                    }
                  )

                $('.cd-image-block').removeClass('content-block-is-visible')
                closeBtn.off(
                  'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend'
                )
              }
            )
        }
      })

      //on desktop - update visible project when clicking the .block-navigation
      blockNavigation.on('click', 'button', function () {
        var direction = $(this),
          indexVisibleblock = imagesList.index(
            imageWrapper.children('li.is-selected')
          )

        if (!direction.hasClass('inactive')) {
          var index = direction.hasClass('cd-next')
            ? indexVisibleblock + 1
            : indexVisibleblock - 1
          updateBlock(index)
        }
      })

      //on desktop - update visible project on keydown
      $(document).on('keydown', function (event) {
        var device = MQ()
        console.log(event.which)
        if (
          event.which == '39' &&
          !blockNavigationNext.hasClass('inactive') &&
          device == 'desktop'
        ) {
          //go to next project
          updateBlock(
            imagesList.index(imageWrapper.children('li.is-selected')) + 1
          )
        } else if (
          event.which == '37' &&
          !blockNavigationPrev.hasClass('inactive') &&
          device == 'desktop'
        ) {
          //go to previous project
          updateBlock(
            imagesList.index(imageWrapper.children('li.is-selected')) - 1
          )
        }
      })

      function updateBlock(n, device) {
        if (!animating) {
          animating = true
          var imageItem = imagesList.eq(n),
            contentItem = contentList.eq(n)

          classUpdate($([imageItem, contentItem]))

          if (device == 'mobile') {
            contentItem.scrollTop(0)
            $('.cd-image-block').addClass('content-block-is-visible')
            contentWrapper
              .addClass('is-visible')
              .one(
                'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
                function () {
                  contentWrapper.find('.cd-close').addClass('is-scaled-up')
                  animating = false
                }
              )
          } else {
            contentList.addClass('overflow-hidden')
            contentItem.one(
              'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
              function () {
                contentItem.siblings().scrollTop(0)
                contentList.removeClass('overflow-hidden')
                animating = false
              }
            )
          }

          //if browser doesn't support transition
          if ($('.no-csstransitions').length > 0) animating = false

          updateBlockNavigation(n)
        }
      }

      function classUpdate(items) {
        items.each(function () {
          var item = $(this)
          item
            .addClass('is-selected')
            .removeClass('move-left')
            .siblings()
            .removeClass('is-selected')
            .end()
            .prevAll()
            .addClass('move-left')
            .end()
            .nextAll()
            .removeClass('move-left')
        })
      }

      function updateBlockNavigation(n) {
        n == 0
          ? blockNavigationPrev.addClass('inactive')
          : blockNavigationPrev.removeClass('inactive')
        n + 1 >= imagesList.length
          ? blockNavigationNext.addClass('inactive')
          : blockNavigationNext.removeClass('inactive')
      }

      function MQ() {
        return window
          .getComputedStyle(imageWrapper.get(0), '::before')
          .getPropertyValue('content')
          .replace(/'/g, '')
          .replace(/"/g, '')
          .split(', ')
      }
    })
  },
  data() {
    return {
      showButton:true,
      hycz1: require('@/components/img/hycz/hysj1.jpg'),
      hycz2: require('@/components/img/hycz/zpjx1.jpg'),
      hycz3: require('@/components/img/hycz/zpjx2.jpg'),
      hycz4: require('@/components/img/hycz/zpjx3.jpg'),
      hycz5: require('@/components/img/hycz/zpjx4.jpg'),
      hycz6: require('@/components/img/hycz/zpjx5.jpg'),
      hycz7: require('@/components/img/hycz/zpjx6.jpg'),
      hycz8: require('@/components/img/hycz/zpjx7.jpg'),
      hycz9: require('@/components/img/hycz/zpjx8.jpg'),
      hycz10: require('@/components/img/hycz/zpjx9.jpg'),
      hycz11: require('@/components/img/hycz/zpjx10.jpg'),
      hycz12: require('@/components/img/hycz/zpjx11.jpg'),
      hycz13: require('@/components/img/hycz/zpjx12.jpg'),
    }
  },
  methods:{
    // 调用全局方法，滚动指定id
    forId(tId) {
      console.log(tId);
      this.$store.dispatch('toID', tId);
    },
  }
}
</script>

<style scoped>
#hysj,
#zpjx {
  margin-top: -83px;
  padding-top: 83px;
}
/* 头部 */
.page-heading {
  background-image: url(@/components/img/hycz/one2.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  width: 100%;
  text-align: center;
}

.page-heading .heading-content h1 {
  font-size: 28px;
  text-transform: uppercase;
  color: #fff;
  letter-spacing: 1px;
  background-color: rgba(5, 5, 5, 0.9);
  display: inline-block;
  margin-bottom: 0;
  margin-top: 220px;
  padding: 20px 40px;
}

.page-heading .heading-content em {
  font-style: normal;
  font-weight: 200;
}
/* 导航栏 */
.zznav {
  position: relative;
  width: 100%;
  height: 65px;
  background-color: #262626;
}
.zzitem {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  padding: 0;
  display: flex; /*弹性布局，使li排成一行*/
}
.zzitem li {
  list-style: none;
}
.zzitem li a {
  position: relative;
  display: block;
  padding: 10px 20px;
  margin: 0 40px;
  text-decoration: none;
  text-transform: uppercase; /*将字符转为大写*/
  color: #8f8c8c;
  font-weight: bold;
  font-size: 22px;
  cursor: pointer;
  /* transition: 0.5s; */
}
.zzitem li a:hover {
  color: #fff;
}
.zzitem li a:before {
  /*a:before，在a链接之前添加新内容，这里添加上下边框*/
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-top: 2px solid #a56c41;
  border-bottom: 2px solid #a56c41;
  transform: scaleY(2); /*拉长边框两倍*/
  opacity: 0; /*边距不显示*/
  transition: 0.5s;
  z-index: -1;
}
.zzitem li a:hover:before {
  transform: scaleY(1); /*拉长边框两倍*/
  opacity: 1;
}
.zzitem li a:after {
  content: '';
  position: absolute;
  top: 1px;
  left: 0;
  width: 100%;
  height: 100%;
  background: #a56c41;
  transform: scale(0);
  transition: 0.5s;
  z-index: -1;
}
.zzitem li a:hover:after {
  transform: scale(1);
}
/* 小滚轮 */
@-webkit-keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
  }
}

@-moz-keyframes badbounce {
  0%,
  100% {
    -moz-transform: translateY(0px);
  }
  10% {
    -moz-transform: translateY(6px);
  }
  30% {
    -moz-transform: translateY(-4px);
  }
  70% {
    -moz-transform: translateY(3px);
  }
  90% {
    -moz-transform: translateY(-2px);
  }
}

@keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
    -moz-transform: translateY(6px);
    -ms-transform: translateY(6px);
    -o-transform: translateY(6px);
    transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
    -moz-transform: translateY(-4px);
    -ms-transform: translateY(-4px);
    -o-transform: translateY(-4px);
    transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
    -moz-transform: translateY(3px);
    -ms-transform: translateY(3px);
    -o-transform: translateY(3px);
    transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    -o-transform: translateY(-2px);
    transform: translateY(-2px);
  }
}

.ss_animate {
  -webkit-animation: badbounce 1s linear;
  -moz-animation: badbounce 1s linear;
  animation: badbounce 1s linear;
}

#ss_menu {
  z-index: 999;
  bottom: 10px;
  width: 60px;
  height: 60px;
  color: #fff;
  position: fixed;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  right: 15px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

#ss_menu > .menu {
  padding: 32px 0 !important;
  display: block;
  position: absolute;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  text-align: center;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.23), 0 3px 10px rgba(0, 0, 0, 0.16);
  color: #fff;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share .circle {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  top: 50%;
  margin-top: -6px;
  left: 12px;
  opacity: 1;
}

#ss_menu > .menu .share .circle:after,
#ss_menu > .menu .share .circle:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  opacity: 1;
  display: block;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
}

#ss_menu > .menu .share .circle:after {
  left: 20.78461px;
  top: 12px;
}

#ss_menu > .menu .share .circle:before {
  left: 20.78461px;
  top: -12px;
}

#ss_menu > .menu .share .bar {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  top: 50%;
  margin-top: -1.5px;
  left: 18px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(30deg);
  -moz-transform: rotate(30deg);
  -ms-transform: rotate(30deg);
  -o-transform: rotate(30deg);
  transform: rotate(30deg);
}

#ss_menu > .menu .share .bar:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  left: 0px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}

#ss_menu > .menu .share.close .circle {
  opacity: 0;
}

#ss_menu > .menu .share.close .bar {
  top: 50%;
  margin-top: -1.5px;
  left: 50%;
  margin-left: -12px;
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(405deg);
  -moz-transform: rotate(405deg);
  -ms-transform: rotate(405deg);
  -o-transform: rotate(405deg);
  transform: rotate(405deg);
}

#ss_menu > .menu .share.close .bar:before {
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(-450deg);
  -moz-transform: rotate(-450deg);
  -ms-transform: rotate(-450deg);
  -o-transform: rotate(-450deg);
  transform: rotate(-450deg);
}

#ss_menu > .menu.ss_active {
  background: #a56c41;
  -webkit-transform: scale(0.7);
  -moz-transform: scale(0.7);
  -ms-transform: scale(0.7);
  -o-transform: scale(0.7);
  transform: scale(0.7);
}

#ss_menu > div {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  width: 60px;
  height: 60px;
  font-size: 10px;
  text-align: center;
  background: #a56c41;
  border-radius: 50%;
  display: table;
}

#ss_menu > div i {
  display: table-cell;
  vertical-align: middle;
}
#ss_menu > div a {
  color: #ffffff;
  text-decoration: none;
}
#ss_menu > div:hover {
  background: #ed9048;
  cursor: pointer;
}

#ss_menu div:nth-child(1) {
  top: -75px;
  left: -25px;
}

#ss_menu div:nth-child(2) {
  top: -25px;
  left: -75px;
}

/* hysg */
.jzcontainer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
.jzh {
  text-align: center;
  font-size: 50px;
  font-weight: 600;
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: #262626 solid 1px;
}
.jzp {
  font-weight: 400;
  font-size: 20px;
}
.jzleft {
  flex: 1;
  margin: 20px;
  padding: 20px;
  background-color: rgba(250, 250, 250, 0.1);
  /* text-align: center;
    line-height: auto; */
  color: #000;
  /* box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 1px, rgba(0, 0, 0, 0.07) 0px 2px 2px, rgba(0, 0, 0, 0.07) 0px 4px 4px, rgba(0, 0, 0, 0.07) 0px 8px 8px, rgba(0, 0, 0, 0.07) 0px 16px 16px; */
}

.jzright {
  flex: 1;
  margin: 20px;
  padding: 20px;
  box-shadow: rgba(136, 165, 191, 0.48) 6px 2px 16px 0px,
    rgba(255, 255, 255, 0.8) -6px -2px 16px 0px;
}

.jzimg {
  max-width: 100%;
  height: auto;
  box-shadow: rgba(136, 165, 191, 0.48) 6px 2px 16px 0px,
    rgba(255, 255, 255, 0.8) -6px -2px 16px 0px;
}
.jzcp {
  width: 99vw;
  height: 90vh;
}
.hyp {
  font-size: 20px;
  font-weight: 400;
}
@media (max-width: 768px) {
  .hyp {
    font-size: 15px;
    font-weight: 400;
  }
  .jzleft,
  .jzright {
    flex: 100%;
  }

  .jzleft {
    order: 1;
    margin: 0;
  }
  .jzh {
    text-align: center;
    font-size: 35px;
    font-weight: 500;
    margin-bottom: 10px;
    padding-bottom: 10px;
  }
  .jzp {
    font-weight: 100;
    font-size: 1em;
  }
  .jzright {
    order: 2;
  }
  .jzcp {
    width: 100vw;
    height: auto;
  }
  .jzcph {
    font-size: 35px !important;
    font-weight: 500 !important;
  }
}
/* 产品内容 */
/* -------------------------------- 

Images block

-------------------------------- */
.jzcph {
  text-align: center;
  padding: 30px 0;
  font-size: 50px;
  font-weight: 600;
  border-top: #000 solid 1px;
  border-bottom: #000 solid 1px;
}
.cd-image-block {
  position: relative;
}
.cd-image-block::before {
  /* this is the layer used to cover the .cd-image-block when the content block becomes visible - mobile only */
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(52, 54, 66, 0.6);
  opacity: 0;
  visibility: hidden;
  -webkit-transition: opacity 0.3s 0s, visibility 0s 0.3s;
  -moz-transition: opacity 0.3s 0s, visibility 0s 0.3s;
  transition: opacity 0.3s 0s, visibility 0s 0.3s;
}
.cd-image-block.content-block-is-visible::before {
  opacity: 1;
  visibility: visible;
  -webkit-transition: opacity 0.3s 0s, visibility 0s 0s;
  -moz-transition: opacity 0.3s 0s, visibility 0s 0s;
  transition: opacity 0.3s 0s, visibility 0s 0s;
}
@media only screen and (min-width: 768px) {
  .cd-image-block::before {
    display: none;
  }
}

.cd-images-list::before {
  /* never visible - this is used in jQuery to check the current MQ */
  content: 'mobile';
  display: none;
}
.cd-images-list > li {
  height: 250px;
  background: #979c9c url(@/components/img/hycz/zp1.png) no-repeat center center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(2) {
  background: #343642 url(@/components/img/hycz/zp2.png) no-repeat center center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(3) {
  background: #982b3c url(@/components/img/hycz/zp3.png) no-repeat center center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(4) {
  background: #338899 url(@/components/img/hycz/zp4.png) no-repeat center center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(5) {
  background: #8b96da url(@/components/img/hycz/zp5.png) no-repeat center center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(6) {
  background: #8b96da url(@/components/img/hycz/zp6.png) no-repeat center center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(7) {
  background: #8b96da url(@/components/img/hycz/zp7.png) no-repeat center center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(8) {
  background: #8b96da url(@/components/img/hycz/zp8.png) no-repeat center center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(9) {
  background: #8b96da url(@/components/img/hycz/zp9.png) no-repeat center center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(10) {
  background: #8b96da url(@/components/img/hycz/zp10.png) no-repeat center
    center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(11) {
  background: #8b96da url(@/components/img/hycz/zp11.png) no-repeat center
    center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(12) {
  background: #8b96da url(@/components/img/hycz/zp12.png) no-repeat center
    center;
  background-size: cover;
}
.cd-images-list > li > a {
  /* used to vertically align the h2 child -  mobile version only */
  display: table;
  height: 100%;
  width: 100%;
}
.cd-images-list h2 {
  /* used to vertically align h2 -  mobile version only */
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  font-size: 3rem;
  color: #ffffff;
  font-weight: 700;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
@media only screen and (min-width: 768px) {
  .cd-images-list::before {
    /* never visible - this is used in jQuery to check the current MQ */
    content: 'desktop';
  }
  .cd-images-list > li > a {
    display: block;
    padding: 4em 3em;
    cursor: default;
    pointer-events: none;
  }
  .cd-images-list h2 {
    font-size: 5.5rem;
    text-align: left;
  }
}

/* -------------------------------- 

Content block

-------------------------------- */
.cd-content-block {
  /* move the block outside the viewport (to the right) - mobile only */
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  height: 100%;
  -webkit-transform: translateX(100%);
  -moz-transform: translateX(100%);
  -ms-transform: translateX(100%);
  -o-transform: translateX(100%);
  transform: translateX(100%);
  -webkit-transition: -webkit-transform 0.3s;
  -moz-transition: -moz-transform 0.3s;
  transition: transform 0.3s;
}
.cd-content-block.is-visible {
  -webkit-transform: translateX(0);
  -moz-transform: translateX(0);
  -ms-transform: translateX(0);
  -o-transform: translateX(0);
  transform: translateX(0);
}
@media screen and (max-width: 768px) {
  .cd-content-block.is-visible {
    border: 1px solid black;
    margin-top: 56px;
  }
}
.cd-content-block > ul {
  height: 100%;
}
.cd-content-block > ul > li {
  position: absolute;
  height: 100%;
  padding: 1em;
  /* overflow-y: scroll; */
  background-color: #ffffff;
  opacity: 0;
  visibility: hidden;
}
.cd-content-block > ul > li.is-selected {
  /* this is the selected content */
  position: relative;
  opacity: 1;
  visibility: visible;
  -webkit-overflow-scrolling: touch;
}
.cd-content-block h2 {
  line-height: 1.2;
  font-weight: 700;
  font-size: 2.3rem;
  margin-bottom: 1em;
}
.cd-content-block p {
  line-height: 1.4;
  color: #85868d;
  font-size: 14px;
}
.cd-content-block .cd-close {
  /* 'X' icon to close the content block -  mobile only */
  position: fixed;
  top: 0;
  right: 0;
  height: 44px;
  width: 44px;
  /* image replacement */
  overflow: hidden;
  text-indent: 100%;
  white-space: nowrap;
  color: transparent;
  -webkit-transform: scale(0);
  -moz-transform: scale(0);
  -ms-transform: scale(0);
  -o-transform: scale(0);
  transform: scale(0);
  -webkit-transition: -webkit-transform 0.2s;
  -moz-transition: -moz-transform 0.2s;
  transition: transform 0.2s;
}
.cd-content-block .cd-close::after,
.cd-content-block .cd-close::before {
  /* these are the 2 lines of the 'X' icon */
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  width: 2px;
  height: 24px;
  background-color: #343642;
  /* Force Hardware Acceleration */
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
}
.cd-content-block .cd-close::after {
  -webkit-transform: translateX(-50%) translateY(-50%) rotate(45deg);
  -moz-transform: translateX(-50%) translateY(-50%) rotate(45deg);
  -ms-transform: translateX(-50%) translateY(-50%) rotate(45deg);
  -o-transform: translateX(-50%) translateY(-50%) rotate(45deg);
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
}
.cd-content-block .cd-close::before {
  -webkit-transform: translateX(-50%) translateY(-50%) rotate(-45deg);
  -moz-transform: translateX(-50%) translateY(-50%) rotate(-45deg);
  -ms-transform: translateX(-50%) translateY(-50%) rotate(-45deg);
  -o-transform: translateX(-50%) translateY(-50%) rotate(-45deg);
  transform: translateX(-50%) translateY(-50%) rotate(-45deg);
}
.cd-content-block .cd-close.is-scaled-up {
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  -o-transform: scale(1);
  transform: scale(1);
}
.no-touch .cd-content-block .cd-close.is-scaled-up:hover {
  -webkit-transform: scale(1.2);
  -moz-transform: scale(1.2);
  -ms-transform: scale(1.2);
  -o-transform: scale(1.2);
  transform: scale(1.2);
}
@media only screen and (min-width: 768px) {
  .cd-content-block {
    /* reset style */
    position: static;
    -webkit-transform: translateX(0);
    -moz-transform: translateX(0);
    -ms-transform: translateX(0);
    -o-transform: translateX(0);
    transform: translateX(0);
  }
  .cd-content-block > ul > li {
    /* reset style */
    opacity: 1;
    visibility: visible;
    padding: 2em;
  }
  .cd-content-block > ul > li.overflow-hidden {
    /* this class is used during the animation (slider change) to hide the scrolling bar */
    overflow: hidden;
  }
  .cd-content-block h2 {
    font-size: 3rem;
  }
  .cd-content-block .cd-close {
    display: none;
  }
}

/* ---------------------------------------------- 

Desktop slider - both image and content blocks

---------------------------------------------- */
@media only screen and (min-width: 768px) {
  .cd-content-block p {
    margin-bottom: 1em;
    line-height: 1.6;
    color: #85868d;
    font-size: 19px;
  }
  .cd-image-block {
    /* slider style - desktop version only */
    width: 40%;
    float: left;
    height: 90vh;
    overflow: hidden;
  }
  .cd-content-block {
    /* slider style - desktop version only */
    width: 60%;
    float: left;
    height: 90vh;
    overflow: hidden;
  }
  .cd-image-block > ul,
  .cd-content-block > ul {
    position: relative;
    height: 100%;
  }
  .cd-image-block > ul > li,
  .cd-content-block > ul > li {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    /* Force Hardware Acceleration */
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    -ms-transform: translateZ(0);
    -o-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    will-change: transform;
    /* by default, the items are moved to the right - relative to their parent elements */
    -webkit-transform: translateX(100%);
    -moz-transform: translateX(100%);
    -ms-transform: translateX(100%);
    -o-transform: translateX(100%);
    transform: translateX(100%);
    -webkit-transition: -webkit-transform 0.5s;
    -moz-transition: -moz-transform 0.5s;
    transition: transform 0.5s;
  }
  .cd-image-block > ul > li.is-selected,
  .cd-content-block > ul > li.is-selected {
    /* this is the visible item */
    position: absolute;
    -webkit-transform: translateX(0);
    -moz-transform: translateX(0);
    -ms-transform: translateX(0);
    -o-transform: translateX(0);
    transform: translateX(0);
  }
  .cd-image-block > ul > li.move-left,
  .cd-content-block > ul > li.move-left {
    /* this is the item hidden on the left */
    -webkit-transform: translateX(-100%);
    -moz-transform: translateX(-100%);
    -ms-transform: translateX(-100%);
    -o-transform: translateX(-100%);
    transform: translateX(-100%);
  }
}
/* -------------------------------- 

Slider navigation

-------------------------------- */
.block-navigation {
  /* this is the slider navigation - desktop version only */
  display: none;
}
@media only screen and (min-width: 768px) {
  .block-navigation {
    display: block;
    position: absolute !important;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 39px !important;
  }
  .block-navigation::after {
    clear: both;
    content: '';
    display: table;
  }
  .block-navigation li {
    position: static !important;
    width: 50% !important;
    height: 50px !important;
    line-height: 50px !important;
    text-align: center !important;
    background-color: rgba(0, 0, 0, 0.5) !important;
    -webkit-transition: background 0.2s;
    -moz-transition: background 0.2s;
    transition: background 0.2s !important;
    transform: translateX(0) !important;
  }
  .block-navigation li:hover {
    background-color: rgba(0, 0, 0, 0.7) !important;
  }
  .block-navigation li:first-of-type {
    float: left;
  }
  .block-navigation li:last-of-type {
    float: right;
  }
  .block-navigation button {
    display: block;
    height: 100%;
    width: 100%;
    color: #ffffff;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .block-navigation button.inactive {
    opacity: 0.3;
    cursor: not-allowed;
  }
}

/* -------------------------------- 

Javascript disabled

-------------------------------- */
@media only screen and (min-width: 768px) {
  .no-js .cd-content-block {
    display: none;
  }

  .no-js .cd-image-block {
    width: 100%;
    overflow: visible;
  }

  .no-js .cd-images-list::after {
    clear: both;
    content: '';
    display: table;
  }

  .no-js .cd-images-list > li {
    position: static;
    width: 50%;
    float: left;
    height: 400px;
    -webkit-transform: translateX(0);
    -moz-transform: translateX(0);
    -ms-transform: translateX(0);
    -o-transform: translateX(0);
    transform: translateX(0);
  }
  .no-js .cd-images-list > li.is-selected {
    position: static;
  }

  .no-js .cd-images-list > li > a {
    cursor: pointer;
    pointer-events: auto;
  }

  .no-js .block-navigation {
    display: none;
  }
}
.jzbutton {
  cursor: pointer;
  border: none;
  background-color: transparent;
  outline: none;
  font-size: 1.6rem;
}
@media screen and (min-width: 2000px) {
  .jzh {
    font-size: 60px;
    margin-bottom: 60px;
    padding-bottom: 60px;
  }
  .jzp {
    font-size: 30px;
  }
  .jzleft {
    padding: 20px 50px 20px 20px;
  }
  .jzimg {
    height: 700px;
    width: 100%;
  }
  .jzcph {
    font-size: 60px;
  }
  /* 头部 */
  .page-heading .heading-content h1 {
    font-size: 40px;
  }
  .zzitem li a {
    margin: 0 50px;
    font-size: 25px;
  }
  .cd-images-list h2 {
    font-size: 7rem;
  }
  .cd-content-block h2 {
    font-size: 5rem;
  }
  .cd-content-block p {
    font-size: 22px;
  }
}
</style>
